// filepath: client/src/routes/loaders/apiUsersLoader.js
import { queryClient } from '#client/utils/queryClient.js';
import { getApiUsersQueryOptions } from '#client/utils/queryOptions/index.js';

/**
 * Loader for API Users route
 * Prefetches API users data before the component renders
 */
export async function apiUsersLoader() {
    // Use ensureQueryData to guarantee data is available before rendering
    // This will use cached data if available, or fetch if needed
    const data = await queryClient.ensureQueryData(getApiUsersQueryOptions());

    return data; // Loader data not directly used; component will access via useQuery
}
